import { render, staticRenderFns } from "./ManageFriend.vue?vue&type=template&id=4bdd6794&scoped=true&"
import script from "./ManageFriend.vue?vue&type=script&lang=js&"
export * from "./ManageFriend.vue?vue&type=script&lang=js&"
import style0 from "./ManageFriend.vue?vue&type=style&index=0&id=4bdd6794&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bdd6794",
  null
  
)

export default component.exports